import { defaultHttpResponse, HttpResponse } from '../auth/AuthInterface';

// definicion de defaults

export const  defaultCitacionSentencia : CitacionSentenciaProps = {
    idCitacionSentencia: 0,
    numeroExpediente: '',
    idAcuerdo: 0,
    idTipoAcuerdo: 0,
    tipoAcuerdo: '',
    idAudiencia: 0,
    idTipoAudiencia: 0,
    tipoAudiencia: '',
    idTipoSentencia: 0,
    tipoSentencia: '',
    idEstatus:0,
    estatus: '',    
}

export const defaultAgregarCitacionSentenciaResponse : AgregarCitacionSentenciaResponse = {
    ...defaultHttpResponse,
    idCitacionSentencia:    0,
    idAcuerdo:              0,
    idTipoAcuerdo:          0,
    tipoAcuerdo:            '',
    idAudiencia:            0,
    idTipoAudiencia:        0,  
    tipoAudiencia:          '',
    idEstatus:              0,
    estatus:                '',
    numeroExpediente:       '',
    idTipoSentencia:        0,
    tipoSentencia:          '',
}

// Creación de interfaces

export interface CitacionSentenciaProps {
    idCitacionSentencia:    number;
    idAcuerdo:              number;
    idAudiencia:            number;
    numeroExpediente:       string;
    idEstatus:              number;
    estatus:                string;
    idTipoAcuerdo:          number;
    tipoAcuerdo:            string;
    idTipoAudiencia:        number;
    tipoAudiencia:          string;
    idTipoSentencia:        number;
    tipoSentencia:          string;
    fecha?:                 Date;
}

export interface BuscarCitacionSentenciaProps {
    idExpediente: number;
    idTipoSentencia: number;
}

export interface AcuerdoCitacionSentenciaProps {
    idAcuerdo:      number;
    idTipoAcuerdo:  number;
    tipoAcuerdo:    string;
    nombre:         string;
    fecha?:         Date;
}

export interface AudienciaCitacionSentenciaProps {
    idAudiencia:    number;
    tipoAudiencia:  string;
    fecha?:         Date;
}

export interface AgregarCitacionSentenciaParams {
    idExpediente:       number;
    idAcuerdo:          number;
    idAudiencia:        number;
    idTipoSentencia:    number;
}

export interface AgregarCitacionSentenciaResponse extends HttpResponse {
    idCitacionSentencia:    number;
    fecha?:                 Date;
    idAcuerdo:              number;
    idTipoAcuerdo:          number;
    tipoAcuerdo:            string;
    idAudiencia:            number;
    idTipoAudiencia:        number;
    tipoAudiencia:          string;
    idEstatus:              number;
    estatus:                string;
    numeroExpediente:       string;
    idTipoSentencia:        number;
    tipoSentencia:          string;
}

export interface CambiarEstatusCitacionSentenciaParams {
    idCitacionSentencia:    number;
    value:                  boolean;
}